




import AdminSettingsAccount from '@/components/Templates/Admin/Settings/Account/Account.vue';

export default {
    name: 'AdminSetupAccountView',
    components: {
        AdminSettingsAccount,
    },
};
